module.exports = __webpack_public_path__ + "84ad4475e9cb6ebd9c833df146244302.svg";